// Version 5 dicembre ore 14:51
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
  useMemo,
} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { IoMdSend as Invia } from 'react-icons/io';
import { FaMicrophone, FaDotCircle, FaStop as Stop } from 'react-icons/fa';
import {
  BsThreeDotsVertical as DotsSettings,
  BsTrash3 as Cestino,
} from 'react-icons/bs';

import NuovaChat from './components/NuovaChat';
import { StateContext } from './components/StateContainer';
import FormGetInfoUser from './components/FormGetInfoUser/FormGetInfoUser';
import useSpeechRecognition from './components/hooks/UseSpeechRecognition';
import PoweredBy from './img/logoChat.png';
import './App.css';
import ModalDeleteChatHistory from './components/modals/ModalDeleteChatHistory';
import translations from './assets/translations/translation';

const Chat = ({ content }) => {
  console.log('Chat is working versione 2');

  const {
    message,
    setMessage,
    dettagliProgetto,
    setDettagliProgetto,
    showFormRequestContacts,
    setShowFormRequestContacts,
    leadCode,
    setStopAgent,
    setLeadCode,
    setShowFormContactFollowChat,
    loading,
    setLoading,
    setBotMessageSent,
    botMessageSent,
    cardBodyRef,
    conversationStarted,
    scriptContextualInformation,
    setScriptContextualInformation,
    setConversationStarted,
  } = useContext(StateContext);

  // 🕒 Per salvare la data del primo messaggio
  const [firstMessageDate, setFirstMessageDate] = useState(null);

  // 🖱️ Hover sugli elementi
  const [hoveredButton, setHoveredButton] = useState(null);
  const handleMouseEnter = useCallback((id) => setHoveredButton(id), []);
  const handleMouseLeave = useCallback(() => setHoveredButton(null), []);

  // 🎨 Colori dinamici
  const hexToRGBA = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const secondaryRGBA = useMemo(() => {
    const color = dettagliProgetto?.secondaryColor || '#000000';
    return hexToRGBA(color, 0.15);
  }, [dettagliProgetto]);

  const hexColorPerSVG = useMemo(() => {
    return dettagliProgetto?.secondaryColor || '#000000';
  }, [dettagliProgetto]);

  const url = new URL(window.location.href);
  const urlProjectCode = url.searchParams.get('projectCode');
  console.log(url);
  const locale = url.searchParams.get('locale') ?? 'it';

  //SubconversationCode
  const subConversation = url.searchParams.get('subConversation') ?? null;

  // ---- STATE ----
  const [error, setError] = useState('');
  const [totalChat, setTotalChat] = useState([]);
  const [disableUserMessageChat, setDisableUserMessageChat] = useState(false);
  const [projectCode, setProjectCode] = useState(urlProjectCode || '');
  const [conversationId, setConversationId] = useState(() =>
    localStorage.getItem(`conversationId-${urlProjectCode}`),
  );

  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const [caricamento, setCaricamento] = useState(false);
  const [reloadIframe, setReloadIframe] = useState(false);
  const [ip, setIP] = useState('');
  const [datiContestoSito, setDatiContestoSito] = useState('');

  const userLastMessageRef = useRef('');

  const { text, startListening, stopListening, isListening } =
    useSpeechRecognition();

  // --------------------------------------------------
  // UTILS
  // --------------------------------------------------
  const scrollToBottom = useCallback(() => {
    if (!cardBodyRef.current) return; // guard clause

    const cardBody = cardBodyRef.current;

    setTimeout(() => {
      if (cardBody) {
        cardBody.scrollTo({
          top: cardBody.scrollHeight - cardBody.clientHeight,
          behavior: 'smooth',
        });
      }
    }, 100);
  }, [cardBodyRef]);

  const shouldShowContactForm = useCallback(
    (project) =>
      project.collectCustomerEmail &&
      project.lead?.collectLeadWhen === 'before-chat' &&
      localStorage.getItem(`showFormRequestContacts-${projectCode}`) !==
        'false',
    [projectCode],
  );

  const shouldAskContactOnFirstMessage = useCallback(
    () =>
      totalChat.length === 0 &&
      dettagliProgetto?.collectCustomerEmail &&
      dettagliProgetto?.lead?.collectLeadWhen === 'first-response' &&
      localStorage.getItem(`showFormRequestContacts-${projectCode}`) !==
        'false',
    [totalChat.length, dettagliProgetto, projectCode],
  );

  const getApiUrlByType = useCallback((type) => {
    switch (type) {
      case 'conversational':
        return `${process.env.REACT_APP_PYTHON_ENGINE}/knots-chatbot`;
      case 'mysql-agent':
        return `${process.env.REACT_APP_PYTHON_ENGINE}/sql-agent`;
      default:
        return `${process.env.REACT_APP_PYTHON_ENGINE}/chatbot`;
    }
  }, []);

  // const buildRequestOptions = useCallback(
  //   (message, codeLead, widget_clicked) => ({
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({
  //       message,
  //       referrer: document.referrer,
  //       datiContestoSito,
  //       conversationId: conversationId,
  //       projectCode: dettagliProgetto.code,
  //       chatHistory: totalChat,
  //       leadCode: leadCode || codeLead,
  //       widgetClicked: widget_clicked,
  //       ip,
  //       link: scriptContextualInformation.currentUrl,
  //       currentNode: localStorage.getItem(`currentNode-${urlProjectCode}`) || 1,
  //       nextNode:
  //         localStorage.getItem(`nextNodeProject-${urlProjectCode}`) || 1,
  //       variables: localStorage.getItem(`variables-${urlProjectCode}`) || '[]',
  //       external_service_knoledge:
  //         localStorage.getItem(`external_service_knoledge-${urlProjectCode}`) ||
  //         '[]',
  //     }),
  //   }),
  //   [
  //     conversationId,
  //     datiContestoSito,
  //     dettagliProgetto,
  //     totalChat,
  //     leadCode,
  //     ip,
  //     scriptContextualInformation,
  //     urlProjectCode,
  //   ]
  // );

  const buildRequestOptions = useCallback(
    (message, codeLead, widget_clicked) => {
      const lsGet = (key, fallback) => {
        try {
          const value = localStorage.getItem(key);
          return value !== null ? value : fallback;
        } catch {
          return fallback;
        }
      };

      const getParsedLS = (key, fallback = []) => {
        try {
          const raw = localStorage.getItem(key);
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : fallback;
        } catch {
          return fallback;
        }
      };

      // --- Gestione subConversation ---
      let finalConversationId = conversationId;
      let finalSubConversationId = null;

      if (subConversation) {
        const subConvArray = getParsedLS(`subConversation-${urlProjectCode}`);

        const found = subConvArray.find(
          (item) => item.subConversationId === subConversation,
        );

        if (found) {
          finalSubConversationId = found.subConversationId;
          finalConversationId = found.conversationId || conversationId;
        }
      }

      // --- Corpo principale ---
      const bodyData = {
        message,
        referrer: document.referrer,
        conversationId: finalConversationId,
        projectCode: dettagliProgetto.code,
        locale: locale ?? 'it',
        chatHistory: totalChat,
        leadCode: leadCode || codeLead,
        widgetClicked: widget_clicked,
        datiContestoSito: scriptContextualInformation?.datiContestoSito || '',
        trackingData: scriptContextualInformation?.trackingData,
        link: scriptContextualInformation.currentUrl,
        currentNode: lsGet(`currentNode-${urlProjectCode}`, 1),
        nextNode: lsGet(`nextNodeProject-${urlProjectCode}`, 1),
        variables: lsGet(`variables-${urlProjectCode}`, '[]'),
        external_service_knoledge: lsGet(
          `external_service_knoledge-${urlProjectCode}`,
          '[]',
        ),
        subConversationId: finalSubConversationId,
      };

      // Aggiungi ip solo se esiste e non è vuoto
      if (ip) {
        bodyData.ip = ip;
      }

      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData),
      };
    },
    [
      conversationId,
      datiContestoSito,
      dettagliProgetto,
      totalChat,
      leadCode,
      ip,
      scriptContextualInformation,
      urlProjectCode,
    ],
  );

  // handleBotResponse — ora accetta l'array e lo normalizza
  const handleBotResponse = useCallback(
    (data, conversation) => {
      // ✅ Normalizza: se è array, merge tutti gli oggetti in uno solo
      const normalized = Array.isArray(data)
        ? Object.assign({}, ...data)
        : data;

      if (normalized.faq_answer) {
        conversation.botMessage = {
          ...conversation.botMessage,
          text: normalized.answer || '',
          faq_answer: true,
          faq_actions: normalized.actions || [],
          interactionCode: normalized.interactionCode || '',
          show_thumbs: normalized.show_thumbs ?? true,
        };
        if (normalized.disable_user_text)
          setDisableUserMessageChat(normalized.disable_user_text);
        if (normalized.currentNodeProject)
          localStorage.setItem(
            `currentNode-${urlProjectCode}`,
            normalized.currentNodeProject,
          );
        if (normalized.nextNodeProject)
          localStorage.setItem(
            `nextNodeProject-${urlProjectCode}`,
            normalized.nextNodeProject,
          );
        if (normalized.var && normalized.var !== '[]')
          localStorage.setItem(
            `variables-${urlProjectCode}`,
            JSON.stringify(normalized.var),
          );
        if (
          normalized.external_service_knoledge &&
          normalized.external_service_knoledge !== '[]'
        )
          localStorage.setItem(
            `external_service_knoledge-${urlProjectCode}`,
            JSON.stringify(normalized.external_service_knoledge),
          );
      } else if (normalized.sql_graphic) {
        StopButtonClick();
        console.log('uyooooo');

        conversation.botMessage.sql_graphic = true;
        conversation.botMessage.dataGraphic = normalized.data || [];
        conversation.botMessage.optionsGraphic = normalized.options || [];
      } else if (normalized.sql_table) {
        StopButtonClick();
        console.log('uyooooo');

        conversation.botMessage.sql_table = true;
        conversation.botMessage.sql_table_content =
          normalized.sql_table_content || normalized.answer || '';
      }

      // ✅ Gestisce link_gestionale (presente nel secondo elemento dell'array)
      if (normalized.link_gestionale) {
        conversation.botMessage.link_gestionale = normalized.link_gestionale;
      }

      setTotalChat((prev) => [...prev.slice(0, -1), conversation]);
    },
    [urlProjectCode],
  );

  // --------------------------------------------------
  // MESSAGING
  // --------------------------------------------------
  const handleSendMessage = useCallback(
    async (messaggio, codeLead, widget_clicked = false) => {
      setDisableUserMessageChat(false);
      document.querySelectorAll('.faq-actions').forEach((el) => {
        el.classList.remove('animationDoneActionsFaq');
        el.classList.add('d-none');
      });

      setStopAgent(false);
      setConversationStarted(true);
      setBotMessageSent(true);
      setIsUserScrolling(false);
      setLoading(true);

      const userMessage = message.trim() || messaggio;
      if (!userMessage) return;

      const conversation = {
        userMessage: { message: userMessage, date: new Date() },
        botMessage: {
          text: '',
          date: new Date(),
          split: false,
          faq_answer: false,
        },
      };
      setTotalChat((prev) => [...prev, conversation]);
      setMessage('');

      try {
        const apiURL = getApiUrlByType(
          localStorage.getItem(`type-project-${projectCode}`),
        );

        // ✅ Una sola chiamata a response.json(), subito dopo fetch
        const response = await fetch(
          apiURL,
          buildRequestOptions(userMessage, codeLead, widget_clicked),
        );

        const data = await response.json(); // ← letto UNA sola volta
        console.log('La risposta è: ', data);

        // ✅ Controlla response.ok DOPO aver letto il body
        if (!response.ok) throw new Error('Errore nella risposta');

        setBotMessageSent(false);
        setLoading(false);

        handleBotResponse(data, conversation);
      } catch (error) {
        console.error('Errore generale:', error);
        setLoading(false);
        setBotMessageSent(false);
        conversation.botMessage.text = 'Errore di rete o server. Riprova.';
        setTotalChat((prev) => [...prev.slice(0, -1), conversation]);
      }
    },
    [
      message,
      projectCode,
      buildRequestOptions,
      getApiUrlByType,
      handleBotResponse,
      setMessage,
    ],
  );

  const ControlsBeforeSendingMessage = useCallback(
    (messaggio, widget_clicked = false) => {
      setShowFormContactFollowChat(false);
      document.querySelectorAll('.faq-actions').forEach((el) => {
        el.classList.remove('animationDone');
        el.classList.add('d-none');
      });

      setMessage(messaggio);

      if (shouldAskContactOnFirstMessage()) {
        setShowFormRequestContacts(true);
      } else {
        handleSendMessage(messaggio, leadCode, widget_clicked);
      }
    },
    [shouldAskContactOnFirstMessage, handleSendMessage, leadCode],
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter' && !conversationStarted) {
        ControlsBeforeSendingMessage(event.target.value);
      }
    },
    [conversationStarted, ControlsBeforeSendingMessage],
  );

  const StopButtonClick = useCallback(() => {
    setStopAgent(true);
    setConversationStarted(false);
  }, [setStopAgent, setConversationStarted]);

  const CancellaCronologiaChat = useCallback(() => {
    const keys = [
      'conversationId',
      'currentNode',
      'nextNodeProject',
      'variables',
      'external_service_knoledge',
    ];

    // --- Gestione subConversation ---
    const subConvKey = `subConversation-${projectCode}`;
    const storedSubConv = localStorage.getItem(subConvKey);

    if (storedSubConv) {
      try {
        const subConvArray = JSON.parse(storedSubConv);

        if (Array.isArray(subConvArray)) {
          // Filtra e rimuove solo quello con subConversationId corrispondente
          const updatedArray = subConvArray.filter(
            (item) => item.subConversationId !== subConversation,
          );

          if (updatedArray.length === 0) {
            // Nessuna sub-conversation rimasta → rimuovo completamente la chiave
            localStorage.removeItem(subConvKey);
          } else {
            // Aggiorno l'array mantenendo le altre sub-conv
            localStorage.setItem(subConvKey, JSON.stringify(updatedArray));
          }
        }
      } catch (e) {
        console.error('Errore nella gestione di subConversation:', e);
      }
    }

    // --- Rimuove le altre chiavi dal localStorage ---
    keys.forEach((key) => {
      localStorage.removeItem(`${key}-${projectCode}`);
    });

    // Ricarica la pagina dopo 100ms
    setTimeout(() => {
      document.location.reload();
    }, 100);
  }, [projectCode, subConversation]);

  // --------------------------------------------------
  // EFFECTS
  // --------------------------------------------------
  useEffect(() => {
    // 📡 1. Recupero IP utente
    if (dettagliProgetto && dettagliProgetto.trackIp) {
      axios
        .get('https://api.ipify.org/?format=json')
        .then((res) => setIP(res.data.ip))
        .catch(console.error);
    } else {
      setIP('');
    }

    console.log('Verifica chiamata useEffect del handleMessage');
    window.parent.postMessage({ action: 'tailorGptReady' }, '*');

    // 📥 2. Ascolto messaggi dal parent
    const handleMessage = (event) => {
      // Filtra i messaggi che non ti interessano
      console.log('📩 Messaggio ricevuto dal parent:', event);

      if (!event.data || event.data.type?.startsWith('webpack')) return;

      console.log('📩 Messaggio ricevuto dal parent:', event.data);

      if (event.data?.action === 'cookieWebSite') {
        setScriptContextualInformation({
          currentUrl: event.data.currentUrl,
          datiContestoSito: event.data.datiContestoSito,
          logo: event.data.logo,
          assistantName: event.data.assistantName,
          trackingData: event.data.trackingData,
        });
      }
      if (event.data?.action === 'reload') {
        setScriptContextualInformation({
          currentUrl: event.data.currentUrl,
          datiContestoSito: event.data.datiContestoSito,
          logo: event.data.logo,
          assistantName: event.data.assistantName,
          trackingData: event.data.trackingData,
        });
      }
    };

    window.addEventListener('message', handleMessage);

    // 🧹 Pulizia listener quando il componente si smonta
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    // Prendi conversationId da localStorage, se non esiste creane uno nuovo
    let conversationId = localStorage.getItem(
      `conversationId-${urlProjectCode}`,
    );
    if (!conversationId) {
      conversationId = `${Date.now()}-${Math.floor(Math.random() * 100000)}`;
      localStorage.setItem(`conversationId-${urlProjectCode}`, conversationId);
    }

    if (subConversation) {
      // Prendi l'array di subConversation dal localStorage o inizializza vuoto
      let subConversationLocalStorage = localStorage.getItem(
        `subConversation-${urlProjectCode}`,
      );
      let subConversations = subConversationLocalStorage
        ? JSON.parse(subConversationLocalStorage)
        : [];

      // Controlla se esiste già un oggetto con questo subConversationId
      const exists = subConversations.some(
        (item) => item.subConversationId === subConversation,
      );

      // Se non esiste, aggiungi il nuovo oggetto
      if (!exists) {
        subConversations.push({
          conversationId: conversationId,
          subConversationId: subConversation,
        });

        localStorage.setItem(
          `subConversation-${urlProjectCode}`,
          JSON.stringify(subConversations),
        );
      }
    }

    setConversationId(conversationId);
  }, [urlProjectCode, subConversation]);

  useEffect(() => {
    // --- Recupero conversationCode corretto ---
    let conversationCode = null;

    const subConvKey = `subConversation-${urlProjectCode}`;
    const storedSubConv = localStorage.getItem(subConvKey);

    if (storedSubConv) {
      try {
        const subConvArray = JSON.parse(storedSubConv);

        if (Array.isArray(subConvArray)) {
          const found = subConvArray.find(
            (item) => item.subConversationId === subConversation,
          );

          if (found && found.conversationId) {
            conversationCode = found.conversationId;
          }
        }
      } catch (err) {
        console.error('Errore parsing subConversation:', err);
      }
    }

    // Fallback se non trovato in subConversation
    if (!conversationCode) {
      conversationCode = localStorage.getItem(
        `conversationId-${urlProjectCode}`,
      );
    }

    // --- Chiamata API ---
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/public/conversation/detail`, {
        projectCode: urlProjectCode,
        subConversationCode: subConversation ?? null,
        conversationCode: conversationCode,
      })
      .then(({ data }) => {
        if (!data.response) return;

        const conversation = data.response.map((msg) => ({
          userMessage: { message: msg.userText, date: msg.date.date },
          botMessage: {
            text: msg.botText.trim(),
            date: msg.date.date,
            split: true,
            faq_answer: false,
          },
        }));

        setTotalChat(conversation);
      })
      .catch(console.error);
  }, [urlProjectCode, subConversation]);

  function setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      console.error('Errore nel salvataggio in localStorage:', e);
      return false;
    }
  }

  useEffect(() => {
    setCaricamento(true);

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/public/project/detail`, {
        projectCode,
        locale,
      })
      .then(({ data }) => {
        setError('');
        setReloadIframe(false);
        setCaricamento(false);
        setDettagliProgetto(data.response);
        localStorage.setItem(`type-project-${projectCode}`, data.response.type);
        const dettagli = data.response;
        console.log('dettagli', dettagli);

        const STORAGE_KEY = `tailorGPT_projectData_${projectCode}`;
        const dataToSave = {
          initialMessage: dettagli.initialMessage,
          primaryColor: dettagli.primaryColor,
          language: dettagli.language,
          assistantName: dettagli.assistantName,
          chatbotIcon: dettagli.chatbotIcon,
          chatBubbleAlignement: dettagli.chatBubbleAlignement,
          createdAt: new Date().toISOString(),
        };
        setLocalStorage(STORAGE_KEY, dataToSave);

        if (shouldShowContactForm(data.response))
          setShowFormRequestContacts(true);
        scrollToBottom();
      })
      .catch((err) => setError(err));
  }, [
    projectCode,
    reloadIframe,
    shouldShowContactForm,
    scrollToBottom,
    setDettagliProgetto,
  ]);

  useEffect(() => {
    const cardBody = cardBodyRef.current;
    const onScroll = () => {
      const nearBottom =
        cardBody.scrollHeight - cardBody.scrollTop - cardBody.clientHeight < 50;
      setIsUserScrolling(!nearBottom);
    };
    cardBody.addEventListener('scroll', onScroll);
    return () => cardBody.removeEventListener('scroll', onScroll);
  }, [cardBodyRef]);

  useEffect(() => {
    if (!isUserScrolling) scrollToBottom();
  }, [botMessageSent, isUserScrolling, scrollToBottom]);

  if (dettagliProgetto)
    document.title = dettagliProgetto.title || 'Ai Assistant';

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(!isOpen);

  return (
    <div className="App">
      <div id="layout-wrapper">
        <div className="main-content m-0 p-0 h-100">
          <div className="page-content p-0">
            {dettagliProgetto &&
            dettagliProgetto.lead &&
            dettagliProgetto.collectCustomerEmail &&
            dettagliProgetto.lead.collectLeadWhen !== 'follow-conversation' ? (
              <FormGetInfoUser
                locale={locale}
                handleSendMessage={handleSendMessage}
                message={message}
                progetto={dettagliProgetto}
                conversationId={conversationId}
                setConversationId={setConversationId}
                setMessage={setMessage}
              ></FormGetInfoUser>
            ) : (
              ''
            )}
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 px-0 position-fixed fixed-top">
                  <div className="w-100 user-chat mt-sm-0">
                    <div
                      className="card"
                      style={{
                        border: 0,
                      }}
                    >
                      <div
                        ref={cardBodyRef}
                        className="card-body"
                        id="cardBodyChat"
                        dir="ltr"
                        style={{
                          overflowX: 'hidden',
                          overflowY: 'scroll',
                          border: 0,
                          position: 'relative',
                        }}
                      >
                        {caricamento ? (
                          <div className="form-outline mt-5">
                            <div className="loading-dots">
                              <div className="loading-dots--dot"></div>
                              <div className="loading-dots--dot"></div>
                              <div className="loading-dots--dot"></div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="chat-conversation py-3">
                              <ul
                                className="list-unstyled mb-0 chat-conversation-message"
                                data-simplebar
                                style={{ fontSize: '0.875rem' }}
                                id="ulList"
                              >
                                <>
                                  <NuovaChat
                                    progetto={dettagliProgetto}
                                    chat={totalChat}
                                    locale={locale}
                                    firstMessageDate={firstMessageDate}
                                    caricamento={caricamento}
                                    totalChat={totalChat}
                                    ControlsBeforeSendingMessage={
                                      ControlsBeforeSendingMessage
                                    }
                                    setIsUserScrolling={setIsUserScrolling}
                                    isUserScrolling={isUserScrolling}
                                    setLoading={setLoading}
                                    message={message}
                                    userLastMessageRef={userLastMessageRef}
                                    setMessage={setMessage}
                                    setTotalChat={setTotalChat}
                                    conversationId={conversationId}
                                    setLeadCode={setLeadCode}
                                  />
                                </>

                                {dettagliProgetto &&
                                dettagliProgetto.lead &&
                                dettagliProgetto.collectCustomerEmail &&
                                dettagliProgetto.lead.collectLeadWhen &&
                                dettagliProgetto.lead.collectLeadWhen ===
                                  'follow-conversation' ? (
                                  <>
                                    <FormGetInfoUser
                                      locale={locale}
                                      handleSendMessage={handleSendMessage}
                                      message={message}
                                      progetto={dettagliProgetto}
                                      conversationId={conversationId}
                                      setConversationId={setConversationId}
                                      setMessage={setMessage}
                                    ></FormGetInfoUser>
                                    <li style={{ height: '70px' }}></li>
                                  </>
                                ) : (
                                  ''
                                )}
                                <li style={{ height: '60px' }}></li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="divider"></div>

                      <div
                        className="position-absolute w-100 text-center p-3"
                        style={{ bottom: '0' }}
                      >
                        {dettagliProgetto && dettagliProgetto.predefinedQueries
                          ? dettagliProgetto.predefinedQueries.map(
                              (query, index) => (
                                <button
                                  key={index} // Assicurati di aggiungere una chiave unica per ogni pulsante
                                  className="btn div-advice-buttons mx-2 font-size-14"
                                  onClick={() =>
                                    ControlsBeforeSendingMessage(query[1])
                                  }
                                  onMouseEnter={() => handleMouseEnter(index)}
                                  onMouseLeave={handleMouseLeave}
                                  style={{
                                    backgroundColor:
                                      hoveredButton === index
                                        ? dettagliProgetto &&
                                          dettagliProgetto.secondaryColor // colore verde
                                        : 'white', // colore bianco
                                  }}
                                >
                                  <p className="m-0">{query[0]}</p>
                                </button>
                              ),
                            )
                          : ''}
                      </div>

                      {caricamento ? (
                        ''
                      ) : (
                        <div
                          className={`py-5 card-footer chat-input-section d-flex flex-fill align-items-start w-100 justify-content-center bg-white footer-chat 
                          position-fixed fixed-bottom`}
                          style={{ zIndex: '999' }}
                        >
                          <div className="footer-row row w-100 d-flex justify-content-center m-0">
                            {/* Bottoni Consiglia Messaggio Al bot */}

                            {/* Fine Bottoni Consiglia Messaggio Al bot */}
                            <div
                              style={{
                                backgroundColor: `${secondaryRGBA}`,
                                height: '50px',
                                borderTop: `${
                                  dettagliProgetto
                                    ? `1px ${dettagliProgetto.secondaryColor} solid`
                                    : ''
                                }`,
                                borderBottom: `${
                                  dettagliProgetto
                                    ? `1px ${dettagliProgetto.secondaryColor} solid`
                                    : ''
                                }`,
                              }}
                              className="w-100 d-flex justify-content-center p-0 align-items-center m-0 px-4"
                            >
                              <div className="w-100 ">
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control search-bar w-100 bg-transparent border-0 shadow-none px-0"
                                    style={{ outline: 'none' }}
                                    placeholder={`${translations[`sendAMessage-${locale}`]}`}
                                    value={message}
                                    onChange={(event) =>
                                      setMessage(event.target.value)
                                    }
                                    onKeyDown={handleKeyDown}
                                    disabled={disableUserMessageChat}
                                  />
                                </div>
                              </div>

                              <div className="col-auto d-flex align-items-center d-none d-md-block">
                                {!conversationStarted ? (
                                  <>
                                    {/* {!isListening ? (
                                      <span
                                        className="m-0 micro-icon d-flex align-items-center justify-content-center"
                                        onClick={startListening}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <FaMicrophone />
                                      </span>
                                    ) : (
                                      <span
                                        className="m-0 micro-icon d-flex align-items-center justify-content-center text-danger registration"
                                        onClick={stopListening}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <FaDotCircle />
                                      </span>
                                    )} */}
                                    <button
                                      type="submit"
                                      className={`btn chat-send w-md waves-effect waves-light d-flex align-items-center justify-content-center border-0 ${
                                        message === '' ? '' : ''
                                      }`}
                                      style={{
                                        backgroundColor: `${
                                          dettagliProgetto
                                            ? dettagliProgetto.secondaryColor
                                            : ''
                                        }`,

                                        color: `white`,

                                        border: '1px grey solid',
                                      }}
                                      onClick={() =>
                                        ControlsBeforeSendingMessage(message)
                                      }
                                    >
                                      <span
                                        className="d-none d-sm-inline-block me-2 text-white"
                                        style={{
                                          color: 'white',
                                        }}
                                      >
                                        {translations[`send-${locale}`]}
                                      </span>
                                      <Invia
                                        fill={`white`}
                                        stroke={`white`}
                                      />{' '}
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    type="submit"
                                    className={`btn chat-send w-md waves-effect waves-light d-flex align-items-center justify-content-center border-0 ${
                                      message === '' ? '' : ''
                                    }`}
                                    style={{
                                      backgroundColor: `${
                                        dettagliProgetto
                                          ? dettagliProgetto.secondaryColor
                                          : ''
                                      }`,

                                      color: `white`,

                                      border: '1px grey solid',
                                    }}
                                    onClick={StopButtonClick}
                                  >
                                    <span className="d-none d-sm-inline-block me-2">
                                      Stop
                                    </span>

                                    <Stop fill={`white`} stroke={`white`} />
                                  </button>
                                )}
                              </div>

                              <div className="col-auto d-flex align-items-center d-block d-md-none">
                                {!conversationStarted ? (
                                  <>
                                    {/* {!isListening ? (
                                      <span
                                        className="m-0 micro-icon d-flex align-items-center justify-content-center"
                                        onClick={startListening}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <FaMicrophone />
                                      </span>
                                    ) : (
                                      <span
                                        className="m-0 micro-icon d-flex align-items-center justify-content-center text-danger registration"
                                        onClick={stopListening}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <FaDotCircle />
                                      </span>
                                    )} */}
                                    <button
                                      type="submit"
                                      className="btn chat-send waves-effect waves-light d-flex align-items-center justify-content-center border-0 rounded-circle p-0 fs-4 "
                                      style={{
                                        backgroundColor: `${
                                          dettagliProgetto
                                            ? dettagliProgetto.secondaryColor
                                            : ''
                                        }`,
                                        height: '40px',
                                        width: '40px',

                                        color: `white`,

                                        border: '1px grey solid',
                                      }}
                                      onClick={() =>
                                        ControlsBeforeSendingMessage(message)
                                      }
                                    >
                                      <Invia fill={`white`} stroke={`white`} />
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    type="submit"
                                    className="btn chat-send waves-effect waves-light d-flex align-items-center justify-content-center border-0 rounded-circle p-0 fs-4 "
                                    style={{
                                      backgroundColor: `${
                                        dettagliProgetto
                                          ? dettagliProgetto.secondaryColor
                                          : ''
                                      }`,
                                      height: '40px',
                                      width: '40px',

                                      color: `white`,

                                      border: '1px grey solid',
                                    }}
                                    onClick={StopButtonClick}
                                  >
                                    <Stop fill={`white`} stroke={`white`} />
                                  </button>
                                )}
                              </div>
                            </div>

                            <div className="w-100 d-flex align-items-start justify-content-between my-2 px-4 mb-4">
                              <div className="d-flex gap-5 align-items-start">
                                {dettagliProgetto &&
                                dettagliProgetto.hideTailorGPTLogo ? (
                                  ''
                                ) : (
                                  <div className="my-1">
                                    <a
                                      href="https://tailorgpt.ai/"
                                      target="_blank"
                                      className="text-decoration-none d-flex"
                                    >
                                      <p
                                        className="font-size-11 m-0"
                                        style={{ color: '#535353' }}
                                      >
                                        Powered By
                                      </p>
                                      <div className="logo-tailor-container d-flex align-items-center gap-2 position-relative overflow-hidden">
                                        <div className="shine"></div>
                                        <img
                                          style={{
                                            width: 'auto',
                                          }}
                                          src={`${PoweredBy}`}
                                          alt="Tailor GPT - your own generative AI"
                                          className="img-fulgeas-chat"
                                        />
                                      </div>
                                    </a>
                                  </div>
                                )}
                                {dettagliProgetto ? (
                                  dettagliProgetto.privacy ? (
                                    <div className="my-1 pb-4 d-flex align-items-center">
                                      <a
                                        className="font-size-11"
                                        style={{ color: '#535353' }}
                                        href={`${dettagliProgetto.privacy}`}
                                        target="_blank"
                                      >
                                        Privacy
                                      </a>
                                    </div>
                                  ) : (
                                    ''
                                  )
                                ) : (
                                  ''
                                )}
                              </div>

                              <div className="my-1 pb-4 d-flex align-items-center">
                                <a
                                  className="font-size-15"
                                  style={{ color: '#535353' }}
                                  type="button"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#offcanvasWithBothOptions"
                                  aria-controls="offcanvasWithBothOptions"
                                >
                                  <DotsSettings />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Offcanvas  */}
                    <div
                      className="offcanvas offcanvas-start w-100 p-0 m-0"
                      data-bs-scroll="true"
                      tabIndex="-1"
                      id="offcanvasWithBothOptions"
                      aria-labelledby="offcanvasWithBothOptionsLabel"
                    >
                      <div className="offcanvas-header">
                        <h5
                          className="offcanvas-title"
                          id="offcanvasWithBothOptionsLabel"
                        >
                          {/* Impostazioni Chat  */}
                          {translations[`chatSettings-${locale}`]}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="offcanvas"
                          id="close-button-cookies-offcanvas"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="offcanvas-body">
                        <button
                          className="text-danger d-flex align-items-center gap-2 bg-transparent"
                          onClick={openModal}
                        >
                          <Cestino />
                          {/* Cancella Cronologia  */}
                          {translations[`clearHistory-${locale}`]}
                        </button>
                      </div>
                    </div>
                    {/* Offcanvas  */}

                    {/* MODALE */}

                    {isOpen && (
                      <ModalDeleteChatHistory
                        dettagliProgetto={dettagliProgetto}
                        locale={locale}
                        CancellaCronologiaChat={CancellaCronologiaChat}
                        setIsOpen={setIsOpen}
                      />
                    )}

                    {/* FINE MODALE  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
